<template>
    <div id="SubidorEvaluaciones_div" class="w-100 px-0 py-0">
        <div id="TituloEstimulos_div" v-if="mostraSubida==true && mostraProceso==false && mostraTerminadas == false">
            <h5 class="label-black" style="margin-bottom: 0px;">EVALUCIONES PARA ESTIMULOS</h5>
            <h6 class="label-black" style="margin-top: 0px;">Exporta listado para generar evaluaciones para estímulos</h6>
        </div>
        <div v-if="mostraSubida==false && mostraProceso==true && mostraTerminadas == false">
            <h5 class="label-black" style="margin-bottom: 0px;">EVALUCIONES PARA ESTÍMULOS</h5>
            <h6 class="label-black" style="margin-top: 0px;">Evaluaciones para estímulos en Proceso</h6>
        </div>
        <div class="row d-flex" v-if="mostraSubida==true && mostraProceso==false && mostraTerminadas == false">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 padding-div-low">
                <div class="area custom-area" >
                    <div v-if="Subido==false && Validado==false">
                        <div class="row">
                            <div class="form-group col-12" id="inicio_div">
                                <label class="label-black">Inicio del Periódo:</label>
                                <input type="text" class="form-control" v-model="Fecha_Inicio" readonly />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" id="fin_div">
                                <label class="label-black">Fin del Periódo:</label>
                                <input type="text" class="form-control" v-model="Fecha_Fin" readonly />
                            </div>
                        </div>
                        <div class="row ">
                            <div class="form-group col-12" id="Limite_div">
                                <label class="label-black">Fecha Limite de Entrega:</label>
                                <input class="form-control" type="date" v-model="Fecha_Limite"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Seleccione el archivo Excel a importar</label>
                                <input type="file" id="archivoaSubir" v-on:change="cargarArchivo($event)" class="form-control" accept=".xls, .xlsx" style="width: 100%"/>
                            </div>
                        </div>
                        <div class="text-right" v-if="archivo!=null">
                            <button class="btn btn-success"  @click='Subir()'>Obtener Registros</button>
                        </div>
                    </div>
                    <div v-if="Subido==true">
                        <div class="form-group">
                            <div class="text-center">
                                <button class="btn btn-warning"  @click='Volver()'>Regresar a importación</button>
                            </div>
                        </div>
                        <div class="form-group" v-if="ListadoRevision.length<=0 && ResultadoFormato.length>0 " >
                            <div class="text-center">
                                <button class="btn btn-success"  @click='GenerarEvaluaciones(ResultadoFormato)'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Crear Evaluaciones&nbsp;&nbsp;&nbsp;&nbsp;</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 padding-div-low">
                <div class="area custom-area">
                    <div v-if="Subido==false">
                        <h5 >
                            <p class="text-warning">NOTA IMPORTANTE:
                            </p>
                        </h5>
                        <h6>
                            <p class="text-warning">Antes de importar los registros para generar solicitud de evaluación para estímulos, corrobore que el formato y datos del documento en excel sean correctos.
                            </p>
                        </h6>
                    </div>
                    <div v-else>
                        <div v-if="ListadoRevision.length<=0">
                            <div class="row">
                                <div class="form-group col-12" >
                                    <h5 class="text-center label-black">VERIFICACIÓN DE DATOS</h5>
                                </div>
                            </div>
                            <div class="row text-primary">
                                <div class="form-group col-12" >
                                    <h5 class="label-black">
                                        Total de evaluados importados: {{ResultadoFormato.length}}
                                    </h5>
                                </div>
                            </div>
                            <div class="row" v-if="ListaAreas.length>0 && ListadoRevision.length<=0">
                                <div class="form-group col-8" >
                                    <select id="catalogoDeTipos" class="form-control" @change="cambiarTipo($event, false)">
                                        <option value= 0 class="text-primary">Seleccione Área</option>
                                        <option class="text-success" v-for="opcion in ListaAreas" :key="opcion.TipoId" :value="opcion.id" >{{opcion.NombreArea}}  {{opcion.NombreDepartamento}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row text-primary">
                                <div class="form-group col -6">
                                    <h6>
                                        Total de evaluados en Área seleccionada: {{mostradoEnTabla.length}}
                                    </h6>
                                </div>
                            </div>
                            <div id="ListaEvaluaciones_table" class="table-responsive">
                                <table class="table table-striped table-light table-hover table-sm table-bordered">
                                    <thead class="thead-custom">
                                        <tr>
                                            <th>Nombre del Evaluado</th>
                                            <th>Evaluadores</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-dark" v-for="Lista in mostradoEnTabla" :key="Lista.EvaluacionId">
                                        <tr>
                                            <td width="150"><h6><span class="badge badge-dark">{{Lista.nombreEvaluado}}</span></h6></td>
                                            <td width="300">
                                                <ul>
                                                    <template v-for="evaluador in Lista.evaluadores">
                                                        <li v-if="evaluador.FormatoCuestionarioId==17"><h6><span class="badge badge-dark">{{evaluador.Evaluador.NombreCompleto}}</span> <span class="badge badge-success">DESEMPEÑO</span></h6></li>
                                                        <li v-else><h6><span class="badge badge-dark">{{evaluador.Evaluador.NombreCompleto}}</span> <span class="badge badge-primary">ACTITUD</span></h6></li>
                                                    </template>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div v-else>
                            <div class="row">
                                <h6 class="text-danger">Verificar datos de los siguientes evaluados/evaluadores</h6>
                            </div>
                            <div id="ListaRevisar_table" class="table-responsive">
                                <table class="table table-striped table-light table-hover table-sm table-bordered">
                                    <thead class="thead-custom">
                                        <tr>
                                            <th>No. Nómina</th>
                                            <th>Nombre</th>
                                            <th>Área</th>
                                            <th>Observaciones</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-dark" v-for="Lista in ListadoRevision">
                                        <tr>
                                            <td class="text-center">{{Lista.NumeroNomina}}</td>
                                            <td>{{Lista.Nombre}}</td>
                                            <td>{{Lista.Area}}</td>
                                            <td>{{Lista.Detalle}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-flex" v-if="mostraSubida==false && mostraProceso==true && mostraTerminadas == false">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 padding-div-low">
                <div class="row">
                    <div class="form-group col-4">
                        <h6 class="label-black">Total de Evaluaciones en Proceso : {{Total}}</h6>
                    </div>
                    <div class="form-group col-4">
                    </div>
                    <div class="form-group col-4">
                        <label class="text-success">Área en proceso de Evaluación:</label>
                        <select id="catalogoDeTipos" class="form-control" @change="cambiarTipo($event, true)">
                            <option value= 0>SELECCIONE UNA ÁREA</option>
                            <option v-for="opcion in ListaAreas" :key="opcion.TipoId" :value="opcion.id" >{{opcion.NombreArea}} {{opcion.NombreDepartamento!="" ? opcion.NombreDepartamento : ""}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-8">
                        <h6 >Evaluaciones en Proceso en Area Seleccionada: {{mostradoEnTabla.length}}</h6>
                    </div>
                </div>
                <div class="row">
                    <div class="table-responsive col-12" id="TableEnProceso">
                        <table class="table table-striped table-light table-hover table-sm" id="tablaEvaluaciones">
                            <thead class="thead-custom">
                                <tr>
                                    <th>Nombre del Evaluado</th>
                                    <th>Puesto</th>
                                    <th>Departamento</th>
                                    <th>Evaluadores Pendientes</th>
                                    <th>Fecha de Entrega</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody class='text-dark'>
                                <template v-for='(evaluacion, indice) in mostradoEnTabla'>
                                <tr v-if="!evaluacion.FiltradoFront" v-bind:key="evaluacion.EvaluacionId">
                                    <td >{{evaluacion.nombreEvaluado}}</td>
                                    <td>{{evaluacion.Puesto}} <i v-if="evaluacion.AlertaHistorialLaboral" class="fas fa-exclamation-triangle" title="Problema de Historial Laboral. Favor de notificar a personal." /></td>
                                    <td>{{evaluacion.Seccion}}<br>{{evaluacion.Departamento}}</td>
                                    <td>
                                        <ul>
                                            <h6><span class="badge badge-danger text-center" v-if="evaluacion.noCuestionariosContestados==0">Progreso {{evaluacion.noCuestionariosContestados}} / {{evaluacion.noCuestionarios}}</span></h6>
                                            <h6><span class="badge badge-warning text-center" v-if="evaluacion.noCuestionariosContestados>0 && evaluacion.noCuestionariosContestados<evaluacion.noCuestionarios"> Progreso {{evaluacion.noCuestionariosContestados}} / {{evaluacion.noCuestionarios}}</span></h6>
                                            <h6><span class="badge badge-success text-center" v-if="evaluacion.noCuestionariosContestados== evaluacion.noCuestionarios" >TERMINADO</span></h6>
                                            <template v-for="evaluador in evaluacion.evaluadores"  >
                                            <li v-if="!evaluador.Contestado" class="text-danger">{{ evaluador.Evaluador.NombreCompleto}}</li>
                                            <li v-else class="text-success">{{evaluador.Evaluador.NombreCompleto}}</li>
                                            </template>
                                        </ul>
                                    </td>
                                    <td>{{evaluacion.FechaLimiteEntregaString}}</td>
                                    <td>
                                        <i class='fa fa-minus-circle' @click='borrarEvaluado(evaluacion, indice)' title="Eliminar Evaluación"/>
                                        <br>
                                        <i class='fas fa-user-edit' @click='cambiarEvaluado(evaluacion, indice)' title="Editar Evaluación"/>
                                    </td>
                                </tr>
                                </template>
                                <!-- <tr v-if="evaluaciones.length == 0"><td colspan="8">No se encontraron evaluaciones en proceso</td></tr> -->
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="row d-flex" v-if="mostraSubida==false && mostraProceso==false && mostraTerminadas==true">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 padding-div-low">
                <div class="row">
                    <div class="form-group col-12 text-center">
                        <h5 class="label-black">Reporte de Evaluaciones para Estímulos {{PeriodoEvaluacion}}</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-4">
                        <label class="text-success">Área para reporte de Evaluación:</label>
                        <select id="catalogoDeTipos" class="form-control" @change="cambiarTipo($event, true)">
                            <option value= 0>Seleccione un Área</option>
                            <option v-for="opcion in ListaAreas" :key="opcion.TipoId" :value="opcion.id" >{{opcion.NombreArea}}</option>
                        </select>
                    </div>
                    <div class="form-group col-4"></div>
                    <div class="form-group col-4">
                        <div v-if="mostradoEnTabla.length>0" class="text-right">
                            <button class="btn btn-success btn-sm"  @click='generarReporte()' title="Imprime reporte del área seleccionada">Generar Reporte</button>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="mostradoEnTabla.length>0">
                    <div class="col-12 table-responsive">
                        <table class="table table-striped table-light table-hover table-sm" id="tablaEvaluacionesTerminadas" >
                            <thead class="thead-custom">
                                <tr>
                                    <th class="col-1"></th>
                                    <th class="col-7">NOMBRE</th>
                                    <th class="col-1 text-center" >BONO</th>
                                    <th class="col-2 text-center">RESULTADO</th>
                                </tr>
                            </thead>
                            <tbody class="text-dark">
                                <tr v-for="(evaluacion, indice) in mostradoEnTabla" v-bind:key="indice">
                                    <td>{{indice+1}}</td>
                                    <td v-if="indice < 3 && parseFloat(evaluacion.Resultado) >= 8"><strong>{{ evaluacion.nombreEvaluado }}</strong></td>
                                    <td v-else>{{ evaluacion.nombreEvaluado }}</td>
                                    <td class="text-center"><i class="fas fa-award" v-if="indice < 3 && parseFloat(evaluacion.Resultado) >= 8"></i></td>
                                    <td class="text-center" v-if="indice < 3 && parseFloat(evaluacion.Resultado) >= 8"><strong>{{ parseFloat(evaluacion.Resultado!=null ? evaluacion.Resultado : 0).toFixed(1) }}</strong></td>
                                    <td class="text-center" v-else>{{ parseFloat(evaluacion.Resultado!=null ? evaluacion.Resultado : 0).toFixed(1) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="mostrarModal==true">
            <modal :Evaluacion= this.EvaluacionSeleccionada :AreaEvaluacion= areaEvaluacion @dialogo='EstatusModal($event)'></modal>
        </div>
    </div>
</template>
<script>

import comun from '@/../static/js/comun'
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import router from '@/router/index'
import axios from 'axios'
import modalCambios from '@/components/SISEVA/Comun/modalCambiosEvaluacion.vue'

export default {
    components: {
        modal: modalCambios
    },
    data(){
    return {
            enumeraciones,
            archivo: null,
            urlDocumento: "",
            parametros: {
                extensionDocumento: ['xls', 'xlsx'],
            },
            PeriodoEvaluacion: "",
            Fecha_Inicio: "",
            Fecha_Fin: "",
            Fecha_Limite: "",
            Subido: false,
            Validado: false,
            Solicitud :{
                NumeroSolicitud: 0,
                ConteoEvaludos: 0
            },
            ResultadoFormato : [],
            AreasEvaluadosBack : [],
            mostradoEnTabla : [],
            ListaAreas: [],
            ListadoRevision: [],
            parametros_Area: {
                id: 0,
                Nombre: ""
            },
            EvaluacionesEnProceso: [],
            mostraSubida: false,
            mostraProceso: false,
            mostraTerminadas :false,
            EvaluacionesTerminadas: [],
            areaEvaluacion: "",
            mostrarModal: false,
            EvaluacionSeleccionada: {},
            enProceso : 0,
            terminadas : 0,
            Total: 0
        }
    },
    methods: {
        cambiarTipo(datos, tipo){
            
            this.parametros_Area.id = parseInt(datos.target.value);
            
            var elementos = this.ListaAreas.find(e=>e.id==this.parametros_Area.id);
            this.areaEvaluacion = parseInt(datos.target.value)>0 ? elementos.NombreArea : "";
            this.mostradoEnTabla = [];
            $('#navListaEvaluaciones_table').remove();
            $('#navTableEnProceso').remove();
            if(tipo==false)
            {
                if(elementos!=undefined)
                {
                    var idsEvaluados = this.AreasEvaluadosBack.filter(a=>a.Area==elementos.NombreArea);
                    idsEvaluados.forEach((elemento)=>{
                        var EvaluadoALista=this.ResultadoFormato.find(a=>a.EvaluadoId==elemento.PersonaId);
                        this.mostradoEnTabla.push(EvaluadoALista);
                    })
                    this.$nextTick(()=> { PaginarTabla('ListaEvaluaciones_table', 5)});
                }
            }
            else
            {
                this.parametros_Area.id = parseInt(datos.target.value);
                var elementos = this.ListaAreas.find(e=>e.id==this.parametros_Area.id);
                this.VerificarEvaluaciones(false, elementos.NombreArea);
            }
        },
        cargarArchivo:function(evento){
             if(this.verificaQueSeaElDocumentoCorrecto(evento)) {                                 
                this.archivo = evento.target.files[0];   
            }           
        },
        verificaQueSeaElDocumentoCorrecto: function(evento) {
            let siEsUnDocumentoValido = false;      
            //Se verifica que haya documento
            if(evento.target.files.length <= 0) {          
            $("#archivoaSubir").val('');
            this.archivo = null;     
            this.mensajeVisor = 'No hay ruta de archivo. Favor de volver a intentar.' 
            return siEsUnDocumentoValido;    
            }

            const nombreCortado = evento.target.files[0].name.split(".");        
            if (this.parametros.extensionDocumento.find(element => element.toLowerCase() == nombreCortado[nombreCortado.length - 1].toLowerCase()) != null)
            siEsUnDocumentoValido = true;
            else{
            let extensiones = "";
            this.parametros.extensionDocumento.forEach((element, index) => {
                extensiones += " ." + element;
                if(index < this.parametros.extensionDocumento.length - 1)
                extensiones += ",";
            });
            comun.mensajeDeAlerta("El documento que esta subiendo no es un archivo valido. El archivo debe ser " + extensiones + ".<br/><br/>Verifique el documento e inténtelo de nuevo.", null, null);
            $("#archivoaSubir").val('');
            this.archivo = null; 
            
            return siEsUnDocumentoValido;
            }
            
            return siEsUnDocumentoValido;
        },
        Subir: function(){
            if(this.archivo!=null && this.Fecha_Limite!="" )//&& (moment(this.Fecha_Limite).format()>moment(this.Fecha_Fin).format()))
            {
                    comun.SeEstaCargandoInformacion(true); 
                    var datosDelFormulario = new FormData();
                    datosDelFormulario.append("Archivo", this.archivo);
                    datosDelFormulario.append("Fecha_Inicio", this.Fecha_Inicio);
                    datosDelFormulario.append("Fecha_Fin", this.Fecha_Fin);
                    datosDelFormulario.append("Fecha_Limite", this.Fecha_Limite);
                    axios.post(api.conexion + api.SISEVA.funcion.ExportarExcelEstimulos, datosDelFormulario,
                        comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, true)
                    ).then(respuesta => { 
                        if(respuesta.data.SiHayError){
                            this.archivo = null;
                            $("#archivoaSubir").val('');
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);                  
                        } else { 
                            this.ListadoRevision = respuesta.data.ListaARevisar;
                            this.AreasEvaluadosBack = respuesta.data.EvaluadosAreas;
                            this.ResultadoFormato = respuesta.data.Evaluaciones;
                            if(this.ListadoRevision.length==0)
                            {
                                this.ListaAreas = this.ObtenerListadoAreas(this.ResultadoFormato, false);
                                this.Validado = true;
                            }
                            else
                            {
                                this.Validado = false
                            }
                            this.Subido= true;
                            this.archivo = null;
                            $("#archivoaSubir").val('');
                            if(this.ListadoRevision.length>10)
                            {
                                this.$nextTick(()=>{PaginarTabla('ListaRevisar_table',10)});
                            }
                        }
                        comun.SeEstaCargandoInformacion(false);
                    }
                    ).catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);                
                    });    
            }
            else
            {
                if(this.Fecha_Limite=="")
                {
                    comun.mensajeDeAlerta("Elija fecha limite de entrega", null, null);
                }
                // if(moment(this.Fecha_Limite)<=moment(this.Fecha_Fin))
                // {
                //     comun.mensajeDeAlerta("La fecha limite de entrega debe ser superior al fin del periódo de evaluación", null, null);
                // }
            }
        },
        FormatoTabla: function (datos)
        {
            let tabla = []
            datos.forEach((elemento)=>{
                tabla.push({
                    EvaluacionId : elemento.EvaluacionId,
                    FechaCreacion : elemento.FechaCreacion,
                    QuienCrea: elemento.QuienCrea,
                    FechaLimiteEntrega: elemento.FechaLimiteEntrega,
                    FechaTerminacion: elemento.FechaTerminacion,
                    ObservacionRH: elemento.ObservacionRH,
                    FechaInicioPeriodoEvaluacion: elemento.FechaInicioPeriodoEvaluacion,
                    FechaFinPeriodoEvaluacion: elemento.FechaFinPeriodoEvaluacion,
                    EvaluadoId: elemento.EvaluadoId,
                    Activo: elemento.Activo,
                    SolicitudEvaluacionId: elemento.SolicitudEvaluacionId,
                    nombreEvaluado: elemento.nombreEvaluado,
                    Notificada: elemento.Notificada,
                    PeriodoLaboralId: elemento.periodoLaboralEvaluado,
                    Titular : elemento.evaluadores.filter(a=>a.FormatoCuestionarioId==17)[0] ,
                    Igual: elemento.evaluadores.filter(a=>a.FormatoCuestionarioId==18)

                })
            })
            return tabla;
        },
        ObtenerListadoAreas: function(listado, tipo)
        {
            let Areas = []
            if(tipo==false)
            {
                let id=1;
                listado.forEach((elemento)=>{
                    var buscaRelacionAreaBack = this.AreasEvaluadosBack.find(a=>a.PersonaId==elemento.EvaluadoId);
                    var chequeo = Areas.find(e=>e.NombreArea==buscaRelacionAreaBack.Area);
                    if (chequeo==undefined || chequeo==false)
                    {
                        Areas.push({
                            id: id,
                            NombreArea: buscaRelacionAreaBack.Area,
                        })
                    }
                    id++
                })
            }
            else 
            {
                let id_x =1;
                listado.forEach((elemento)=>{
                    
                    var chequeo = Areas.find(e=>e.NombreArea ==elemento.Area);// && e.NombreDepartamento==elemento.Departamento);
                    if(chequeo == undefined || chequeo == false)
                    {
                        Areas.push({
                            id: id_x,
                            NombreArea: elemento.Area,
                        })
                        id_x++
                    }

                })
                
            }
            Areas.sort((a,b)=>(a.NombreArea>b.NombreArea ? 1:-1))
            return Areas;
        },
        Volver(){
            this.archivo=null;
            this.ListaAreas = [];
            //this.EvaluacionesObtenidas =[];
            this.ResultadoFormato = [];
            this.mostradoEnTabla = [];
            this.Subido= false;
            this.Validado= false;
            this.ListadoRevision = [];
        },
        GenerarEvaluaciones: function(lista)
        {
            var Evaluaciones = [];
            lista.forEach((elemento)=>{
                var evaluadores = [];
                evaluadores.push (elemento.Titular);
                $.each(elemento.Igual, function(id, prueba)
                {
                    evaluadores.push(prueba)
                })
                Evaluaciones.push({
                    EvaluacionId: elemento.EvaluacionId,
                    Activo: elemento.Activo,
                    EvaluadoId: elemento.EvaluadoId,
                    FechaCreacion : elemento.FechaCreacion,
                    FechaFinPeriodoEvaluacion: elemento.FechaFinPeriodoEvaluacion,
                    FechaInicioPeriodoEvaluacion: elemento.FechaInicioPeriodoEvaluacion,
                    FechaLimiteEntrega: elemento.FechaLimiteEntrega,
                    FechaTerminacion: elemento.FechaTerminacion,
                    Notificada: elemento.Notificada,
                    ObservacionRH: elemento.ObservacionRH,
                    PeriodoLaboralId : elemento.periodoLaboralEvaluado,
                    QuienCrea: elemento.QuienCrea,
                    evaluadores : elemento.evaluadores,
                    SolicitudEvaluacionId: elemento.SolicitudEvaluacionId
                })
            });
            
            let peticion = { "Evaluaciones" : Evaluaciones, "AreasEvaluados": this.AreasEvaluadosBack};
            console.log(peticion)
            comun.SeEstaCargandoInformacion(true); 
            axios.post(api.conexion + api.SISEVA.funcion.RegistrarEvaluacionesParaEstimulo, peticion,
                        comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                    ).then(respuesta => { 
                        if(respuesta.data.SiHayError){
                            this.archivo = null;
                            $("#archivoaSubir").val('');
                            console.log(respuesta);
                            comun.SeEstaCargandoInformacion(false); 
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);                  
                        } 
                        else
                        { 
                           this.Solicitud.NumeroSolicitud =  respuesta.data.Solicitud;
                           this.Solicitud.ConteoEvaludos = respuesta.data.ConteoEvaluados;
                           this.ResultadoFormato =[];
                           this.ListaAreas = [];
                           this.mostradoEnTabla= [];
                           comun.SeEstaCargandoInformacion(false);
                           comun.mensajeDeAlerta("Se ha generado la Solicitud para Evaluaciones de Estimulos #:" + this.Solicitud.NumeroSolicitud + '<br>Total de Evaluados : ' + this.Solicitud.ConteoEvaludos, null, null);
                           this.VerificarEvaluaciones(true, "");
                        }
                    }
                    ).catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);                
                    });    
        },
        VerificarEvaluaciones (filtro, AreaNombre){
            $('#navTableEnProceso').remove();
            this.EvaluciacionesEnProceso = [];
            //this.ListaAreas = [];
            this.mostradoEnTabla = [];
            let peticion = {
                "FechaInicio" : this.Fecha_Inicio,
                "FechaFinal" : this.Fecha_Fin,
                "AreasFiltro" : filtro,
                "AreaEstimulo" : AreaNombre
            }
            comun.SeEstaCargandoInformacion(true); 
            axios.post(api.conexion + api.SISEVA.funcion.VerificarEnProcesoEstimulos, peticion,
                        comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                    ).then(respuesta => { 
                        if(respuesta.data.SiHayError){
                           
                            console.log(respuesta);
                            comun.SeEstaCargandoInformacion(false); 
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);                  
                        } 
                        else
                        { 
                            this.EvaluacionesEnProceso = respuesta.data.Evaluaciones;
                            this.EvaluacionesTerminadas = respuesta.data.Terminadas;
                            this.AreasEvaluadosBack = respuesta.data.EvaluadosAreas;
                            this.Total = respuesta.data.ConteoEvaluados
                            this.enProceso =respuesta.data.ConteoEnProceso;
                            this.terminadas =respuesta.data.ConteoTerminadas;
                            if(AreaNombre=="")
                            {
                                this.ListaAreas =this.ObtenerListadoAreas(this.AreasEvaluadosBack, true);
                            }
                            if(this.enProceso>0 || this.terminadas>0)
                            {
                                
                                if(this.enProceso>0 && this.terminadas==0)
                                {
                                    this.mostraSubida = false;
                                    this.mostraProceso = true;
                                    this.mostraTerminadas = false;
                                    if(this.EvaluacionesEnProceso.length>0)
                                    {
                                        this.mostradoEnTabla= this.EvaluacionesEnProceso
                                        this.$nextTick(()=> { PaginarTabla('TableEnProceso', 5)});
                                       
                                    }
                                };
                                if(this.enProceso>0 && this.terminadas>0)
                                {
                                    this.mostraSubida = false;
                                    this.mostraProceso = true;
                                    this.mostraTerminadas = false;
                                    if(this.EvaluacionesEnProceso.length>0)
                                    {
                                        this.mostradoEnTabla= this.EvaluacionesEnProceso
                                        this.$nextTick(()=> { PaginarTabla('TableEnProceso', 5)});
                                       
                                    }
                                };
                                if(this.enProceso==0 && this.terminadas>0 )
                                {
                                    this.mostraSubida = false;
                                    this.mostraProceso = false;
                                    this.mostraTerminadas = true;
                                    if(this.EvaluacionesTerminadas.length>0)
                                    {
                                        this.mostradoEnTabla= this.EvaluacionesTerminadas
                                        this.$nextTick(()=> { PaginarTabla('TableEnProceso', 5)});
                                    }
                                };   
                            }
                            else
                            {
                                this.mostraSubida = true;
                                this.mostraProceso = false;
                                this.mostraTerminadas = false;
                            }
                            comun.SeEstaCargandoInformacion(false);
                        }
                    }
                    ).catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);                
                    });
        },
        borrarEvaluado(Evaluacion, indice){
            var peticion = {
                "esPrueba": false,
                "EvaluacionId": Evaluacion.EvaluacionId
                };

            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Desea desactivar las evaluaciones para " + Evaluacion.nombreEvaluado + "?",
                buttons: {
                  cancel: {
                    label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                  },
                  confirm: {
                    label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                  }
                },
                callback: (respuestaSalir) => {
                        if (respuestaSalir) {
                            comun.SeEstaCargandoInformacion(true);
                            axios.post(api.conexion + api.SISEVA.funcion.DesactivarEvaluacion, peticion).then(response => {
                            if (response.data.SiHayError == false)
                            {
                                //En caso de que la petición sea exitosa
                                var Index1 = this.EvaluciacionesEnProceso.indexOf(Evaluacion);
                                var Index2 = this.mostradoEnTabla.indexOf(Evaluacion);
                                this.EvaluciacionesEnProceso.splice(Index1,1);
                                this.mostradoEnTabla.splice(Index2,1);
                            }
                            else 
                            {
                                console.error(response);
                                comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
                            }
                            comun.SeEstaCargandoInformacion(false);
                            })
                            .catch(e => {
                                console.error("encontre un error " + e);
                                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
                            });
                        }
                    }
                });
        },
        cambiarEvaluado(Evaluacion, indice){
            this.EvaluacionSeleccionada = Evaluacion;
            this.mostrarModal=true;
        },
        generarReporte: function () {
            var popupWin = window.open("", "_blank", "width=563,height=750");
            popupWin.document.open();
            popupWin.document.write(
                "<html><head><title>PODER JUDICIAL DEL ESTADO DE AGUASCALIENTES - SISEVA</title>"
            );
            popupWin.document.write(
                "<style>  tr.page-break  { display: block; page-break-after: always; }</style>"
            );
            popupWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            popupWin.document.write(                '<link href="/static/css/bootstrap.min.css" rel="stylesheet">'            );
            popupWin.document.write(                '<link href="/static/css/all.min.css" rel="stylesheet">'            );
            popupWin.document.write(                '<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">'            );
            popupWin.document.write("</head><body >");
            popupWin.document.write('<div class="col-md-12" style="page-break-before: always;">');
            popupWin.document.write('   <div class="area">');
            popupWin.document.write('       <div class="row">');
            popupWin.document.write('           <div class="form-group col-3 align-self-center"">');
            popupWin.document.write('               <img src="/static/img/logo-pj-transparente-negro.d628a6d.png" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/>');            
            popupWin.document.write('           </div>');
            popupWin.document.write('           <div class="form-group col-6 align-self-center text-center">');
            popupWin.document.write('               <div>')
            popupWin.document.write("                   <h3>CONTRALORÍA INTERNA</h3>");
            popupWin.document.write('               </div>')
            popupWin.document.write('               <div>')
            popupWin.document.write("                   <h5>SISTEMA DE EVALUACIÓN DEL DESEMPEÑO</h5>");
            popupWin.document.write('               </div>')
            popupWin.document.write('           </div>');
            popupWin.document.write('           <div class="form-group col-3 align-self-center"">');
            popupWin.document.write('           </div>');
            popupWin.document.write('       </div>');
            popupWin.document.write('       <div class="row">');
            popupWin.document.write('           <div class="form-group col-12 align-self-center text-center">');
            popupWin.document.write("               <h6>REPORTE DE EVALUACIONES PARA ESTÍMULOS "+ this.PeriodoEvaluacion +"</h6>");
            popupWin.document.write('           </div>');
            popupWin.document.write('       </div>');
            popupWin.document.write('       <br>');
            popupWin.document.write('       <div class="row">');
            popupWin.document.write('           <div class="form-group col-12 align-self-center text-left">');
            popupWin.document.write("               <h5>Área:  "+this.areaEvaluacion+"</h5>");
            popupWin.document.write('           </div>');
            popupWin.document.write('       </div>');
            popupWin.document.write('       <br>');
            popupWin.document.write('       <div class="row">');
            popupWin.document.write('<table class="table table-striped table-light table-hover" id="tablaEvaluaciones" style="font-size: 14px;">' );
            var resultados = document.getElementById("tablaEvaluacionesTerminadas").innerHTML;

            resultados = resultados
                .split('style="display: none; opacity: 5;"')
                .join('style="opacity: 5; display: table-row;"');
            resultados = resultados
                .split('style="opacity: 5; display: none;"')
                .join('style="opacity: 5; display: table-row;"');

            resultados = resultados
                .split('class="visible-element"')
                .join('style="opacity: 5"');

            popupWin.document.write(resultados);
            popupWin.document.write("</table>");
            popupWin.document.write('       </div>');
            popupWin.document.write('   </div>');
            popupWin.document.write('</div>');
            popupWin.document.write("</body></html>");

            var css = '@page { size: auto;  margin: 10mm 23mm 10mm 23mm; }',
            head = popupWin.document.head || document.getElementsByTagName('head')[0],
            style = popupWin.document.createElement('style');

            style.type = 'text/css';
            style.media = 'print';

            if (style.styleSheet) {
            style.styleSheet.cssText = css;
            } else {
            style.appendChild(popupWin.document.createTextNode(css));
            }
            head.appendChild(style);
            setTimeout(function () {
                popupWin.print();
            }, 1000);
            popupWin.document.close();
            popupWin.focus();
            this.ImpresionConcluida = true;
        },
        SeparadorAreas: function(dato)
        {
            let Areas = { AreadId: 0, DepartamentoId: 0, NombreArea: "", NombreDepartamento: ""}
            switch (dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.Area.AreaId)
            {
                case 39:
                    console.log(dato.Evaluador.PersonaId)
                    if(dato.Evaluador.PersonaId==2112)
                    {
                        Areas.AreaId = dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.Area.AreaId;
                        Areas.DepartamentoId = dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento!=null ? dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.TipoDepartamentoId : null;
                        Areas.NombreArea = "Informática Civil";
                        //Areas.NombreDepartamento = dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento !=null ? dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.Nombre : null
                    };
                    if(dato.Evaluador.PersonaId==2113)
                    {
                        Areas.AreaId = dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.Area.AreaId;
                        Areas.DepartamentoId = dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento!=null ? dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.TipoDepartamentoId : null;
                        Areas.NombreArea = "Informática Penal";
                        //Areas.NombreDepartamento = dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento !=null ? dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.Nombre : null
                    };
                    break;
                default : 
                        Areas.AreaId = dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.Area.AreaId;
                        Areas.DepartamentoId = dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento!=null ? dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.TipoDepartamentoId : null;
                        Areas.NombreArea = dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre;
                        Areas.NombreDepartamento = dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento !=null ? dato.Evaluador.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.Nombre : null
                    break;
            };
            return Areas;
        },
        EstatusModal(valor){
            this.mostrarModal=valor.Esatus;
            if(valor.Editado==true)
            {
                this.VerificarEvaluaciones(false, valor.NombreArea);
            }
        }
    },
    mounted (){
        var date = new Date();
        this.Fecha_Inicio = new Date(date.getFullYear(), 0, 1).toISOString().split("T")[0];
        this.Fecha_Fin = new Date(date.getFullYear(), 10, 30).toISOString().split("T")[0];
        this.Fecha_Limite = new Date(date.getFullYear(), 11, 1).toISOString().split("T")[0];
        this.PeriodoEvaluacion = date.getFullYear();
        this.VerificarEvaluaciones(true, "");
    }
}
</script>
<style scoped>
    input[type="text"]:read-only {
    background: #f3f3f3;
    }
    input[type="date"] {
    background: #f3f3f3;
    }
    input[type="file"] {
    background: #f3f3f3;
    }

    input[type="text"]:read-only:focus {
        color: #f3f3f3;
    }

    .thead-custom {
    background-color: #004746;
    color: white;
    }
    .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/GenerarEvaluacionesEstimulos.vue